module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_viesi-d73fb368aae6ca4632523f85a845bfa8.png";